module.exports = __webpack_public_path__ + "files/4a94079f56ee7571168bd4978927e42d.png";